module.exports = __webpack_public_path__ + "static/media/post_4.a077bdbd.jpeg";